import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=7163be3a&scoped=true&"
import script from "./LayoutAuth.vue?vue&type=script&lang=js&"
export * from "./LayoutAuth.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=7163be3a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163be3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
